import {
    Box,
    Card,
    CardActions,
    CardContent,
    InputLabel,
    TextField,
    Typography,
} from "@mui/material";
import React from "react";
import GreyButton from "../components/GreyButton";
import { ReactComponent as SwyftxLogo } from "../assets/6385b3d7140115fbf69f92db_SwyftX Logo.svg";
import PopUpModal from "../components/PopUpModal";
import MessageModal from "../components/MessageModal";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { URL, origin } from "../config";
import { Helmet } from "react-helmet-async";

export default function Swyftx() {
    const [popUpOpen, setPopUpOpen] = React.useState(false);
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [error, setError] = React.useState("");
    const [key, setKey] = React.useState("");
    const navigate = useNavigate();
    const theme = createTheme({
        seconday: "#EEEEEE",
    });

    const handleLink = (e) => {
        e.preventDefault();

        if (!key) {
            setError("key required");
        } else {
            setPopUpOpen(true);
            const data = {
                apiKey: key,
            };
            fetch(`${URL}/link/swyftx`, {
                method: "POST",
                mode: "cors",
                credentials: "include",
                headers: {
                    "content-type": "application/json",
                    Origin: `${origin}`,
                },
                body: JSON.stringify(data),
            })
                .then((response) => {
                    if (response.ok === false) {
                        setError(response.statusText);
                        navigate(`/${response.status}`);
                        throw new Error(data.message);
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data.error) {
                        setError(data.error.message);
                        throw new Error(data.error.message);
                    }
                    setPopUpOpen(false);
                    setSuccessOpen(true);
                })
                .catch((err) => {
                    console.error(err);
                    setPopUpOpen(false);
                });
        }
    };

    const closeMessage = () => {
        setSuccessOpen(false);
        setError("");
    };
    return (
        <>
            <Helmet>
                <title>WealthWatch | link Swyftx</title>
            </Helmet>
            <ThemeProvider theme={theme}>
                <Card>
                    <CardContent
                        sx={{
                            background:
                                "linear-gradient(315deg, #63a4ff 0%, #83eaf1 74%)",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{ fontWeight: 200, py: 1 }}
                        >
                            <SwyftxLogo
                                style={{
                                    height: "22px",
                                    width: "80px",
                                    marginLeft: -5,
                                }}
                            />
                        </Typography>
                        <Box
                            sx={{
                                fontWeight: 200,
                                py: 2,
                                fontSize: 15,
                                fontFamily: "sans-serif",
                            }}
                        >
                            Get information about your account. Including total
                            value, value of each coin held, available funds and
                            the cash currency.
                            <br></br>
                            In order to get this information use Swyftx public
                            developer API. Each account can be accessed with an
                            API key unique to that account This is the key that
                            you need to submit below.
                            <br></br>
                            <Typography variant="h6" sx={{ py: 1 }}>
                                To generate your account API key follow the
                                following steps:
                            </Typography>
                        </Box>
                    </CardContent>
                    <Box
                        sx={{
                            background:
                                "linear-gradient(135deg, #ffffff 0%, #d7e1ec 74%)",
                        }}
                    >
                        <InputLabel sx={{ mx: 1 }}>
                            Link your Swyftx account
                        </InputLabel>
                        <CardActions sx={{ py: 1 }}>
                            <TextField
                                variant="outlined"
                                value={key}
                                onChange={(e) => setKey(e.target.value)}
                                label="API key"
                                sx={{
                                    width: "30%",
                                    "@media (max-width: 75em)": {
                                        width: "100%",
                                    },
                                }}
                            >
                                API key
                            </TextField>
                        </CardActions>
                        <GreyButton
                            disabled={!key.length}
                            onClick={handleLink}
                            sx={{ m: 1 }}
                        >
                            Submit
                        </GreyButton>
                    </Box>
                </Card>
                <PopUpModal open={popUpOpen} />
                <MessageModal
                    severity="error"
                    title="error"
                    open={error ? true : false}
                    onClose={closeMessage}
                >
                    {error}
                </MessageModal>
                <MessageModal
                    severity="success"
                    title="success"
                    open={successOpen}
                    onClose={closeMessage}
                >
                    Linked Swyftx account
                </MessageModal>
            </ThemeProvider>
        </>
    );
}
